<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="宠物ID" prop="petId" >
        <a-input v-model="form.petId" placeholder="请输入宠物ID" />
      </a-form-model-item>
      <a-form-model-item label="设备ID" prop="deviceId" >
        <a-input v-model="form.deviceId" placeholder="请输入设备ID" />
      </a-form-model-item>
      <a-form-model-item label="用户ID" prop="userId" >
        <a-input v-model="form.userId" placeholder="请输入用户ID" />
      </a-form-model-item>
      <a-form-model-item label="统计日期" prop="statDate" >
      </a-form-model-item>
      <a-form-model-item label="屋主睡眠时长(分钟)" prop="ownerSleepMinutes" >
        <a-input v-model="form.ownerSleepMinutes" placeholder="请输入屋主睡眠时长(分钟)" />
      </a-form-model-item>
      <a-form-model-item label="共同睡眠时长(分钟)" prop="sharedSleepMinutes" >
        <a-input v-model="form.sharedSleepMinutes" placeholder="请输入共同睡眠时长(分钟)" />
      </a-form-model-item>
      <a-form-model-item label="非睡眠时长(分钟)" prop="awakeMinutes" >
        <a-input v-model="form.awakeMinutes" placeholder="请输入非睡眠时长(分钟)" />
      </a-form-model-item>
      <a-form-model-item label="24小时时间轴分段JSON，用于环形图渲染" prop="timelineJson" >
        <a-input v-model="form.timelineJson" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getSleepDaily, addSleepDaily, updateSleepDaily } from '@/api/mibo/sleepDaily'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        petId: null,

        deviceId: null,

        userId: null,

        statDate: null,

        ownerSleepMinutes: null,

        sharedSleepMinutes: null,

        awakeMinutes: null,

        timelineJson: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        petId: [
          { required: true, message: '宠物ID不能为空', trigger: 'blur' }
        ],
        deviceId: [
          { required: true, message: '设备ID不能为空', trigger: 'blur' }
        ],
        userId: [
          { required: true, message: '用户ID不能为空', trigger: 'blur' }
        ],
        statDate: [
          { required: true, message: '统计日期不能为空', trigger: 'blur' }
        ],
        ownerSleepMinutes: [
          { required: true, message: '屋主睡眠时长(分钟)不能为空', trigger: 'blur' }
        ],
        sharedSleepMinutes: [
          { required: true, message: '共同睡眠时长(分钟)不能为空', trigger: 'blur' }
        ],
        awakeMinutes: [
          { required: true, message: '非睡眠时长(分钟)不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        petId: null,
        deviceId: null,
        userId: null,
        statDate: null,
        ownerSleepMinutes: null,
        sharedSleepMinutes: null,
        awakeMinutes: null,
        timelineJson: null,
        createTime: null,
        remark: null,
      }
                                  },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getSleepDaily({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateSleepDaily(this.form).then(response => {

              if(response.success) {
                this.$message.success('修改成功',3)
                this.open = false
                this.$emit('ok')
              } else {
                let messageInfo = response.message || response.msg || '修改失败';
                this.$message.error(messageInfo);
              }

            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addSleepDaily(this.form).then(response => {
              if(response.success) {
                this.$message.success('新增成功',3)
                this.open = false
                this.$emit('ok')
              } else {
                let messageInfo = response.message || response.msg || '新增失败';
                this.$message.error(messageInfo);
              }

            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
